export const DEFAULT_VALUES = {
  brand: null,
  benchmark: null,
  dashboardName: '',
}
